import EditInfo from './EditInfo';
export default EditInfo;